<template>
  <div>
    <div class="sub-title my-3">필답 평가</div>
    <div>
      <folder-label label="NCS 교과" :open="true">
        <mdb-row class="underline bolder my-3">
          <mdb-col md="6">과목명</mdb-col>
          <mdb-col md="3" class="text-right">1차 평가</mdb-col>
          <mdb-col md="3" class="text-right">2차 평가</mdb-col>
        </mdb-row>
        <div v-for="(s, i) in subjects.NCS" :key="i">
          <div class="title my-3"><mdb-icon  icon="chalkboard-teacher" /> {{s.name}}</div>
          <mdb-row class="ml-3 my-1 underline" v-for="(l, i) in s.lectures" :key="i"
            :class="{'red-text': isRetry(l.code)}">
            <mdb-col md="6"><mdb-icon  icon="chalkboard" /> {{l.name}}</mdb-col>
            <mdb-col md="3" class="text-right">
              <test-status :score="getScore(l.code, 1)" :testDate="getTestDate(l.code, 1)"
                @test="onTest(l.name, l.code, 1)" @view-result="onViewResult(l.name, l.code, 1)"/>
            </mdb-col>
            <mdb-col md="3" class="text-right">
              <test-status :score="getScore(l.code, 2)" :testDate="getTestDate(l.code, 2)"
                @test="onTest(l.name, l.code, 2)" @view-result="onViewResult(l.name, l.code, 2)"/>
            </mdb-col>
          </mdb-row>
        </div>
      </folder-label>
      <br>
      <folder-label label="비 NCS 교과" :open="true">
        <mdb-row class="underline bolder my-3">
          <mdb-col md="6">과목명</mdb-col>
          <mdb-col md="3" class="text-right">1차 평가</mdb-col>
          <mdb-col md="3" class="text-right">2차 평가</mdb-col>
        </mdb-row>
        <mdb-row v-for="(s, i) in subjects.NONNCS" :key="i" class="my-3 title underline" :class="{'red-text': isRetry(s.name)}">
          <mdb-col md="6"><mdb-icon  icon="chalkboard-teacher" /> {{s.name}}</mdb-col>
          <mdb-col md="3" class="text-right">
            <test-status :score="getScore(s.name, 1)" :testDate="getTestDate(s.name, 1)"
                @test="onTest(s.name, s.name, 1)" @view-result="onViewResult(s.name, s.name, 1)"/>
          </mdb-col>
          <mdb-col md="3" class="text-right">
            <test-status :score="getScore(s.name, 2)" :testDate="getTestDate(s.name, 2)"
              @test="onTest(s.name, s.name, 2)" @view-result="onViewResult(s.name, s.name, 2)"/>
          </mdb-col>
        </mdb-row>
      </folder-label>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import FolderLabel from '@/components/common/FolderLabel.vue'
import TestStatus from '@/components/test/TestStatus.vue';
export default {
  components: { FolderLabel, TestStatus },
  name: 'StudentWritingTest',
  props: ['training'],
  data: () => ({
    subjects: {},
    tests: {},
    answers: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['failScore'])
  },
  methods: {
    async load () {
      if (this.profile.training) {
        const training = this.profile.training._id
        const student = this.profile._id
        this.subjects = await this.$getSubjects(training)
        this.tests = await this.$getWritingTest(training)
        this.answers = await this.$getWritingTestAnswer(this.profile._id)
      }
    },
    getTestDate (code, seq) {
      const t = this.tests[code]
      return t && t[seq] ? this.$strDate(t[seq].testDate) : ''
    },
    getScore (code, seq) {
      const a = this.answers[code]
      return a && a[seq] ? a[seq].score : ''
    },
    isTestDate (code, seq) {
      const t = this.tests[code]
      return t && t[seq] ? this.$isTestDate(t[seq].testDate) : false
    },
    isRetry (code) {
      const score = this.getScore(code, 1)
      return score && (score < this.failScore)
    },
    onViewResult (name, code, seq) {
      const training = this.profile.training._id
      const student = this.profile._id
      this.$router.push({
        name: 'StudentWritingTestView',
        query: { training, name, code, seq, student }
      })
    },
    onTest (name, code, seq) {
      const training = this.profile.training._id
      const student = this.profile._id
      this.$router.push({
        name: 'StudentWritingTestExam',
        query: { training, name, code, seq, student }
      })
    }
  },
  created () {
    this.load()
  },
  watch: {
    profile () {
      this.load()
    }
  }

}
</script>
<style scoped>
.red-text {
  font-weight: 900;
}
</style>
